<template>
  <zj-layout-container>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :disabled="editable" style="height:100%;">
      <el-tabs class="zj-user-org-tabs" v-model="OgrVal" tab-position="left" height="100%">
        <el-tab-pane
          :key="item.name"
          v-for="(item) in  OrgOptions"
          :label="item.OrgianizationName"
          :name="item.PersonOrgianiztionId"
        >
          <UserListControl
            @loading="showLoading"
            @loadingFinish="hideLoading"
            :ref="item.PersonOrgianiztionId"
            :ResourceTypeId="ResourceTypeId"
            :PersonOrgianiztionId="item.PersonOrgianiztionId"
            :InputUsersids="existingReceivers"
          ></UserListControl>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </zj-layout-container>
</template>
<script>
import MyApis from "../../../apis";
import UserListControl from "./UserListControl";
export default {
  name: "ZjUserOrgControl",
  controller: "UI",
  action: "UserOrgControl",
  components: {
    UserListControl
  },
  props: {
    editable: { type: Boolean, default: false },
    ResourceTypeId: { type: String },
    existingReceivers:Object
  },
  data() {
    return {
      ruleForm: {},
      OrgOptions: [],
      OgrVal: ""
    };
  },
  created: function() {
    this.showLoading('加载中...');
    new MyApis.PersonOrganiztionApi()
      .FindByConditions({
        ResourceTypeId:this.$props.ResourceTypeId,
        PageSize: 20,
        PageIndex: 1,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0
      })
      .then(r => {
        var data = r.data.Data;
        if (data && data.length > 0) {
          this.OrgOptions = data;
          this.OgrVal = this.OrgOptions[0].PersonOrgianiztionId;
        }
        this.hideLoading();
      })
      .catch(e => {
        console.error(e);
        this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        this.hideLoading();
      });
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    showLoading(text) {
      this.$emit('loading', text);
    },
    hideLoading() {
      this.$emit('loadingFinish');
    },
    GetUserIds() {
      var userids = [];
      for (var i = 0; i < this.OrgOptions.length; i++) {
        var item = this.OrgOptions[i];
        var chil = this.$refs[item.PersonOrgianiztionId][0];
        var usids = chil.Usersids;
        for (var j = 0; j < usids.length; j++) {
          userids.push(usids[j]);
        }
      }
      return userids;
    },
    GetCheckedUserItems() {
      var result = [];
      for (var i = 0; i < this.OrgOptions.length; i++) {
        var item = this.OrgOptions[i];
        var chil = this.$refs[item.PersonOrgianiztionId][0];
        var checkedUserItems = chil.CheckedUserItems;
        result = result.concat(checkedUserItems);
      }
      return result;
    },

  }
};
</script>